import { CirclePlus, Plus } from 'lucide-react';
import { DeckardIconWrapper } from './DeckardIcon';

export const AddIcon = DeckardIconWrapper({ Icon: Plus, CircleIcon: CirclePlus });
